/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import BaseUrls from '../../../../utils/baseUrls';
import { prefixPath } from '../../../../utils/helpers';
import '../../../../css/checkbox.css';
import apiBackendInstance from '../../../../utils/axios';

export type TeamsChannelInput = {
  commChannelName?: string,
  organizationId?: string,
  isDefault: boolean,
  isAlertDefault: boolean,
  webhookUrl: string,
};

export type TeamsChannelConfig = {
  webhookUrl: string,
};

export type CommunicationChannelBody = {
  commChannelName: string,
  commChannel: string,
  organizationId?: string,
  isDefault: boolean,
  isAlertDefault: boolean,
  authInfo: TeamsChannelConfig,
  createdAtTimestamp?: string,
  updatedAtTimestamp?: string,
};

export type TestCommunicationChannelNotificationBody = {
  channel: string,
  authInfo: TeamsChannelConfig,
};

const TeamsChannelModel = () => {
  const [commChannelName, setCommChannelName] = useState('');
  const commChannel = 'MS Teams';
  const [webhookUrl, setWebhookUrl] = useState('');
  const [saveBtnDisable, setSaveBtnDisable] = useState(true);
  const [commChannelNameValidateMessage, setCommChannelNameValidateMessage] = useState(false as boolean|string);
  const [webhookUrlValidateMessage, setWebhookUrlValidateMessage] = useState(false as boolean|string);

  const baseUrl = window.location.origin;
  const theme = BaseUrls.getkey();
  const logo = baseUrl + prefixPath(`/img/${theme}/navLogo.png`);
  const spinner = baseUrl + prefixPath(`/img/${theme}/spin.svg`);
  const infoImg = baseUrl + prefixPath(`/img/${theme}/info.svg`);
  const teamIcon = baseUrl + prefixPath(`/img/${theme}/microsoftteams.svg`);
  const commChannelNameValidateHandler = (): boolean => {
    if (commChannelName.length > 64) {
      setCommChannelNameValidateMessage('invalid cred name, cred name length exceed 64');
      return false;
    } if (commChannelName === '' || commChannelName.length === 0) {
      setCommChannelNameValidateMessage('Name is empty');
      return false;
    }
    return true;
  };
  const webhookUrlValidateHandler = (): boolean => {
    if (webhookUrl === '' || webhookUrl.length === 0) {
      setWebhookUrlValidateMessage('Webhook Url is empty');
      return false;
    }
    return true;
  };
  const validate = () => {
    if (!commChannelNameValidateHandler()) return false;
    if (!webhookUrlValidateHandler()) return false;
    return true;
  };

  const displayResultMessage = (divId: string) => {
    const allMessageDivId = ['succ', 'fail', 'testSucc', 'testFail'];
    const messageDiv = document.getElementById(divId);

    allMessageDivId.map((elementId) => {
      const elementDiv = document.getElementById(elementId);
      if (elementDiv) elementDiv.style.display = 'none';
      return elementId;
    });
    if (messageDiv) messageDiv.style.display = 'block';
  };

  const createCommChannelBtn = () => {
    const spinnerDiv = document.getElementById('spinnerDiv');
    setSaveBtnDisable(true);
    if (spinnerDiv) {
      spinnerDiv.style.display = 'block';
    }
    apiBackendInstance.post(BaseUrls.registerUserCommunicationChannel(), {
      commChannelName,
      commChannel,
      isDefault: false,
      isAlertDefault: true,
      authInfo: {
        webhookUrl,
      },
    } as CommunicationChannelBody).then((response) => {
      const { data } = response;
      if (data.success) {
        const localVal = localStorage.getItem('updateChannelState');
        if (localVal && localVal === 'yes') { localStorage.setItem('updateChannelState', 'no'); } else {
          localStorage.setItem('updateChannelState', 'yes');
        }
        if (spinnerDiv) {
          spinnerDiv.style.display = 'none';
        }
        displayResultMessage('succ');
        setTimeout(() => { window.close(); }, 3000);
      }
    }).catch(() => {
      // setTimeout(() => { window.close(); }, 3000);
      const localVal = localStorage.getItem('updateChannelState');
      if (localVal && localVal === 'yes') { localStorage.setItem('updateChannelState', 'no'); } else {
        localStorage.setItem('updateChannelState', 'yes');
      }
      setSaveBtnDisable(false);
      if (spinnerDiv) {
        spinnerDiv.style.display = 'none';
      }
      displayResultMessage('fail');
    });
  };

  const sendTestMessageChannelBtn = () => {
    const testChannelBtn: any = document.getElementById('testChannelBtn');
    const spinnerDiv = document.getElementById('spinnerDiv');
    if (testChannelBtn) {
      testChannelBtn.disabled = true;
    }
    if (spinnerDiv) {
      spinnerDiv.style.display = 'block';
    }
    apiBackendInstance.post(BaseUrls.testUserCommunicationChannelNotification(), {
      channel: commChannel,
      authInfo: {
        webhookUrl,
      },
    } as TestCommunicationChannelNotificationBody).then((response) => {
      const { data } = response;
      if (data.success) {
        if (testChannelBtn) {
          testChannelBtn.disabled = false;
        }
        if (spinnerDiv) {
          spinnerDiv.style.display = 'none';
        }
        displayResultMessage('testSucc');
        const div3 = document.getElementById('checkTest');
        if (div3) div3.style.display = 'block';
        setSaveBtnDisable(false);
      }
    }).catch(() => {
      // setTimeout(() => { window.close(); }, 3000);
      const div3 = document.getElementById('checkTest');
      if (div3) div3.style.display = 'block';
      if (testChannelBtn) {
        testChannelBtn.disabled = false;
      }
      if (spinnerDiv) {
        spinnerDiv.style.display = 'none';
      }
      displayResultMessage('testFail');
    });
  };
  return (
    <>
      <div id="status" />
            <main>
            <div id="succ" className="alert alert-success" style={{ display: 'none' }} role="alert">Teams communication channel successfully added.</div>
            <div id="testSucc" className="alert alert-success" style={{ display: 'none' }} role="alert">Teams communication channel message send successfully.</div>
            <div className="alert alert-danger" id="fail" style={{ display: 'none' }} role="alert">There was an error on adding the communication channel</div>
            <div className="alert alert-danger" id="testFail" style={{ display: 'none' }} role="alert">There was an error on sending test message.</div>
                <div className="container d-flex justify-content-center mt-4 pt-5">
                    {/* right part starts here */}
                    <section className="col-xl-5 addCloudBody col-lg-5 col-md-7 col-sm-12 p-5">
                        <div className="col-xl-10 mx-auto">
                            <div className="text-center mt-5 mb-4">
                             <img src={logo} className="img-responsive" alt="logo" />
                            </div>
                            <h6 className="text-center fw-bold">
Add your
{' '}
<img
  src={teamIcon}
  height="15px"
  alt=""
/>
{' '}
{commChannel}
{' '}
Channel
                            </h6>
<h6 className="mb-5 text-center">
Guide to generate
{' '}

<a href="https://learn.microsoft.com/en-us/microsoftteams/platform/webhooks-and-connectors/how-to/add-incoming-webhook" target="_blank" rel="noreferrer">
{commChannel}
{' '}
Webhook
</a>
</h6>
                            <div className=" form-floating cordaversion addCloudField d-flex">
                                <input
                                    type="text"
                                    className={`form-control addCloudField col-11 ${commChannelNameValidateMessage ? 'is-invalid' : ''}`}
                                    placeholder="Name"
                                    onChange={(e) => { setCommChannelName(e.target.value); }}
                                    onFocus={() => { setCommChannelNameValidateMessage(false); }}
                                />
                                <label htmlFor="floatingPassword" className="form-pswd">
                                    Name
                                </label>
                                <span title="Communication Channel Name to save on platform">
                                      <img className="mt-3 mx-2" src={infoImg} alt="" />
                                </span>

                            </div>
                            {commChannelNameValidateMessage !== false && (
                              <div className="text text-danger text-center">
                                            {commChannelNameValidateMessage}
                              </div>
                            )}
                            <div className=" mt-3">
                                <div className=" form-floating cordaversion d-flex ">
                                    <input
                                        type="text"
                                        className={`form-control addCloudField col-11 ${webhookUrlValidateMessage ? 'is-invalid' : ''}`}
                                        placeholder="Teams Webhook URL"
                                        onChange={(e) => { setWebhookUrl(e.target.value); }}
                                        onFocus={() => { setWebhookUrlValidateMessage(false); }}
                                    />
                                    <label htmlFor="floatingPassword" className="form-pswd">
                                        Teams Webhook URL
                                    </label>

                                    <span title="Teams incoming webhook url of your channel">
                                      <img className="mt-3 mx-2" src={infoImg} alt="" />
                                    </span>
                                </div>
                            </div>
                            {webhookUrlValidateMessage !== false && (
                                      <div className="text text-danger text-center">
                                            {webhookUrlValidateMessage}
                                      </div>
                            )}
                            <div id="spinnerDiv" className="text-center mx-5 p-3" style={{ position: 'absolute', display: 'none', zIndex: 10 }}>
                              <img className="mx-5" src={spinner} alt="spinnner" />
                            </div>
                            <div className="mt-4 mb-5  col-xl-12 col-lg-12 col-md-12 text-center">
                              <div id="checkTest" className="" style={{ display: 'none' }}>Check the Test Message in your Channel. Once received, Click on Save button to continue.</div>
                                <button type="button" id="createChannelBtn" className="btn comingSoon" disabled={saveBtnDisable} onClick={() => { if (validate()) createCommChannelBtn(); }}>
                                    Save
                                </button>
                                {' '}
                                <button type="button" id="testChannelBtn" className="btn comingSoon" onClick={() => { if (validate()) sendTestMessageChannelBtn(); }}>
                                  Send Test Message
                                </button>
                            </div>
                        </div>
                    </section>
                    {/* right part ends here */}
                </div>
            </main>
    </>
  );
};

export default TeamsChannelModel;